import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors, MediaQuery, zIndexes } from '../../../theme/style-helpers';
import Close from '../../../assets/icons/Close.svg';
import CloseGray from '../../../assets/icons/CloseGray.svg';

export const Overlay = styled.div`
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  position: fixed;
  z-index: ${zIndexes.MODAL};

  ${MediaQuery.xLarge`
      background-color:  rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(2px);
  `};
`;

export const Panel = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: ${colors.WHITE};
  z-index: ${zIndexes.MODAL + 1};
  padding: 24px;
  transform: translateX(100%);

  ${MediaQuery.small`
    width: 466px;
    right: 0;
  `};
`;

export const PanelHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  height: max-content;
`;

export const PanelBody = styled.div`
  display: grid;
  margin-top: 16px;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  row-gap: 32px;
  padding: 24px;
`;

export const ProfileInfo = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  row-gap: 8px;
`;

export const Greetings = styled.h2`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  margin: 0;
`;

export const Email = styled.p`
  color: #63666A;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.01em;
  margin: 0;
`;

export const Menu = styled.div`
  border-top: 1px solid #D9D9D6;
  border-bottom: 1px solid #D9D9D6;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  padding: 12px 0;
`;

export const MenuItem = styled(Link)`
  width: max-content;
  padding: 16px 12px 16px 0;
  display: grid;
  grid-template-columns: max-content max-content;
  align-items: center;
  column-gap: 16px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  };

  p {
    margin: 0;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: ${colors.BLACK};
  }

  * {
    pointer-events: none;
  }
`;

export const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;

  * {
    pointer-events: none;
  }

  object {
    width: 20px;
  }

  &:hover div {
    background: url(${Close}) center center no-repeat;
    background-size: 30px;
    filter: none;
  }
`;

export const CloseIcon = styled.div`
  width: 30px;
  height: 30px;
  border: none;
  background: url(${CloseGray}) center center no-repeat;
  filter: brightness(0%);
  background-size: 30px;
`;

export const LogoutCTA = styled.button`
  display: grid;
  grid-template-columns: max-content auto;
  column-gap: 8px;
  align-items: center;
  cursor: pointer;
  padding: 0;
  border: 0;
  background-color: transparent;

  &:hover {
    text-decoration: underline;
  };

  * {
    pointer-events: none;
  }

  p {
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin: 0;
  }
`;

export const Container = styled.div`
  display: flex;

  ${Panel} {
    transition: transform .15s ease-in;
    transform:  ${({ $isOpen }) => ($isOpen ? 'translateX(0)' : 'translateX(100%)')};
  };

  ${Overlay} {
    display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  };
`;
